import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FpNavbarComponent } from "../common/fp-navbar/fp-navbar.component";
import { FpFooterComponent } from "../common/fp-footer/fp-footer.component";
import { AppEnvironmentService } from '../../../../ui-framework/global-services/app-environment.service';


@Component({
  selector: 'app-about-us',
  imports: [FpNavbarComponent, FpFooterComponent, RouterLink],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutUsComponent {
  constructor(private readonly appEnvironmentService: AppEnvironmentService) {}

  get homeRoute(): string {
    return this.appEnvironmentService.isLoggedIn ? '/dashboard' : '/authentication';
  }
}
